{
	"cardHeader": "Accesează declarațiile tale",
	"supplierTitle": "Ești furnizorul unei declarații evoZero?",
	"supplierDescription": "Gestionează declarațiile pentru materialele tale evoZero.",
	"loginButton": "Autentificare"
}
